import { render, staticRenderFns } from "./HomeDataStatistics.vue?vue&type=template&id=08b7ccbf&scoped=true&"
import script from "./HomeDataStatistics.vue?vue&type=script&lang=js&"
export * from "./HomeDataStatistics.vue?vue&type=script&lang=js&"
import style0 from "./HomeDataStatistics.vue?vue&type=style&index=0&id=08b7ccbf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b7ccbf",
  null
  
)

export default component.exports